import { z } from '../utils/zod.js';
import { dataResponse } from '../utils/response-templates.js';
export const ADMIN_DEFAULT_PAGE_SIZE = 25;
export const ADMIN_MAX_PAGE_SIZE = 100;
// Oversized pages are clamped server-side instead of rejected, so a hand-edited URL still answers.
export const adminPaginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce
        .number()
        .int()
        .min(1)
        .default(ADMIN_DEFAULT_PAGE_SIZE)
        .openapi({ description: `Clamped to ${ADMIN_MAX_PAGE_SIZE}` }),
});
export const adminBooleanQuerySchema = z.enum(['true', 'false']).transform((value) => value === 'true');
export const adminPageSchema = (item) => z.object({
    items: z.array(item),
    page: z.number().int(),
    pageSize: z.number().int(),
    total: z.number().int(),
});
export const adminPageResponse = (item) => dataResponse(adminPageSchema(item));
